import { type ReactNode, useEffect } from 'react';
import { onSessionEnded } from '@/lib/api/client';
import { bootstrapSession } from './session';
import { useAuthStore } from './store';

/** Restores the session on load and reacts to forced sign-outs (failed refresh). */
export function AuthProvider({ children }: { children: ReactNode }) {
  const setUser = useAuthStore((s) => s.setUser);
  const setLoading = useAuthStore((s) => s.setLoading);
  const reset = useAuthStore((s) => s.reset);

  useEffect(() => {
    let active = true;
    setLoading();
    bootstrapSession().then((user) => {
      if (active) setUser(user);
    });
    const unsubscribe = onSessionEnded(() => reset());
    return () => {
      active = false;
      unsubscribe();
    };
  }, [setUser, setLoading, reset]);

  return <>{children}</>;
}
